"use client";

import { useLocale } from "@/components/providers/LocaleProvider";
import { LOCALES, type Locale } from "@/locales";

/**
 * EN / বাং pill switcher. The whole pill toggles locale on click.
 * Sets the locale cookie and triggers `router.refresh()` via LocaleProvider.
 */
export default function LocaleSwitcher({ className }: { className?: string }) {
  const { locale, setLocale } = useLocale();

  const labelFor = (l: Locale) => (l === "bn" ? "বাং" : "EN");
  const toggleLocale = () => setLocale(locale === "en" ? "bn" : "en");

  return (
    <button
      type="button"
      aria-label={`Language: ${locale === "bn" ? "Bengali" : "English"}. Click to switch.`}
      onClick={toggleLocale}
      className={`inline-flex items-center rounded-full border border-light-border bg-dark-gray p-1 text-xs cursor-pointer ${className ?? ""}`}
    >
      {LOCALES.map((l) => {
        const active = l === locale;
        return (
          <span
            key={l}
            aria-hidden
            className={`px-3 py-1 rounded-full transition-colors duration-200 pointer-events-none ${
              active ? "bg-white text-black" : "text-white"
            }`}
          >
            {labelFor(l)}
          </span>
        );
      })}
    </button>
  );
}
